// @ts-nocheck
import React, { useContext, useEffect, useState, forwardRef } from 'react'
import { motion } from 'framer-motion'
import FlipMove from 'react-flip-move'
import { NotificationProps } from './Notification.types'

import { NotificationContext } from './Notification.context'
import Icon from '../Icon/Icon'
import Portal from '../Portal/Portal'
const Notification = forwardRef<HTMLDivElement>((props: NotificationProps, ref) => {
    const { id, title, message, handleRemove, hideAfter, type = 'default' } = props
    const [show, setShow] = useState(true)

    const remove = () => {
        handleRemove(id)
    }

    useEffect(() => {
        if (hideAfter) {
            // Set auto delete timer
            setTimeout(() => {
                remove()
            }, hideAfter)
        }
    }, [])

    const variants = {
        show: { opacity: 1, x: 0 },
        hide: { opacity: 0, x: '100%' },
    }

    return (
        <div ref={ref} className={`r-notification-item r-type-${type}`}>
            <div className='r-notification-title-container'>
                <div className='r-title'>{title}</div>
                <button onClick={remove} style={{ background: 'none', padding: 0, border: 'none', color: 'inherit' }}>
                    <Icon type={'window-close'} size={'sm'} />
                </button>
            </div>

            <div className='r-notification-body'>{message}</div>
        </div>
    )
})

const NotificationWrapper = () => {
    const { notifications, remove } = useContext(NotificationContext)

    if (notifications.length < 1) {
        return null
    }

    return (
        <Portal container={document.body}>
            <div data-testid='Notification' className='r-Notification-wrapper'>
                <FlipMove
                    staggerDurationBy='30'
                    duration={500}
                    enterAnimation='accordionVertical'
                    leaveAnimation='accordionVertical'
                    typeName={null}
                >
                    {notifications.map((n, i) => (
                        <Notification key={n.id} {...n} handleRemove={remove} />
                    ))}
                </FlipMove>
            </div>
        </Portal>
    )
}

export default NotificationWrapper
